import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Dataset } from '@ca/core/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ca-modal-info',
    templateUrl: './modal-info.component.html',
    styleUrls: ['./modal-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalInfoComponent {
    @Input() title = this.translateService.instant('MODAL_INFO.TITLE');
    @Input() message = '';
    @Input() buttonText = this.translateService.instant('MODAL_INFO.OK');
    @Input() conversionStatusButtonText = this.translateService.instant('MODAL_INFO.DATASET_DETAIL_BUTTON_TEXT');
    @Input() isAtDatasetList?: boolean = false;
    @Input() currentDataset?: Dataset;

    inputText: string = '';

    constructor(
        private activatedRoute: ActivatedRoute,
        private activeModal: NgbActiveModal,
        private router: Router,
        private translateService: TranslateService,
    ) {}

    close(): void {
        this.activeModal.close();
    }

    openDataset(datasetId: string): void {
        this.router.navigate([], {
            queryParams: { ...this.activatedRoute.snapshot.queryParams, ...{ datasetId, folder: 'Images' } },
            relativeTo: this.activatedRoute,
        });
    }
}
